import { render, staticRenderFns } from "./CreateStudentAccount.vue?vue&type=template&id=17ce605c&"
import script from "./CreateStudentAccount.vue?vue&type=script&lang=js&"
export * from "./CreateStudentAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports